import Exercise from 'assets/images/dashboard/excercise.png';
import Diet from 'assets/images/dashboard/diet.png';
import Sleep from 'assets/images/dashboard/sleep.png';
import GeneralTest from 'assets/images/dashboard/lipid-profile.png';
import BloodTest from 'assets/images/dashboard/blood-test.png';
import EssentialNutrient from 'assets/images/dashboard/essential-nutrients.png';
import MetabolicPanel from 'assets/images/dashboard/metabolic.png';
// import Hydration from 'assets/images/dashboard/hydration.png';
import Thyroid from 'assets/images/dashboard/thyroid.png';
import VitaminD from 'assets/images/dashboard/vitamin-d.png';
import Choleterol from 'assets/images/dashboard/cholesterol.png';
import Kidney from 'assets/images/dashboard/kidney.png';
import Liver from 'assets/images/dashboard/liver.png';
import BloodGlucose from 'assets/images/dashboard/blood-glucose.png';
import Bone from 'assets/images/dashboard/calcium.png';
import Hemoglobin from 'assets/images/dashboard/hemoglobin.png';
import Lung from 'assets/images/dashboard/lungs.png';
import Heart from 'assets/images/dashboard/heart.png';
import Medicine from 'assets/images/dashboard/medicine.png';
import ElectroCardiogram from 'assets/images/dashboard/electrocardiogram.png';
import Stress from 'assets/images/dashboard/stress.png';
import WaterIntake from 'assets/images/dashboard/water-intake.png';

export const REPORT_IMAGE_MAPPER = Object.freeze({
  cbc: Hemoglobin,
  hemoglobin: Hemoglobin,
  'white blood cell': Hemoglobin,
  'red blood cell': Hemoglobin,
  'blood count': Hemoglobin,

  cmp: MetabolicPanel,
  electrolytes: MetabolicPanel,
  metabolic: MetabolicPanel,

  lipid: Choleterol,
  cholesterol: Choleterol,
  ldl: Choleterol,
  triglycerides: Choleterol,

  pulmonary: Lung,
  respiratory: Lung,
  'oxygen saturation': Lung,
  lung: Lung,
  pft: Lung,

  echocardiogram: Heart,
  heart: Heart,
  ecg: Heart,
  cardiovascular: Heart,
  cardiac: Heart,
  'electrocardiogram (ecg)': Heart,
  bradycardia: Heart,
  pulse: Heart,
  prq: Heart,
  cardiorespiratory: Heart,
  'blood pressure': Heart,
  'holter monitor': Heart,

  thyroid: Thyroid,
  tsh: Thyroid,
  t3: Thyroid,
  t4: Thyroid,
  hashimoto: Thyroid,
  hormone: Thyroid,
  'thyroid function test': Thyroid,

  'liver function': Liver,
  alt: Liver,
  alp: Liver,
  bilirubin: Liver,
  liver: Liver,

  creatinine: Kidney,
  egfr: Kidney,
  Kidney: Kidney,
  bun: Kidney,
  kidney: Kidney,

  sleep: Sleep,
  apnea: Sleep,
  polysomnography: Sleep,
  'sleep study': Sleep,
  'poor sleep': Sleep,

  'stress management': Stress,
  cortisol: Stress,
  'mental health evaluation': Stress,
  hrv: Stress,
  'stress index': Stress,
  stress: Stress,

  deficiency: EssentialNutrient,
  vitamins: EssentialNutrient,
  folate: EssentialNutrient,
  b12: EssentialNutrient,
  tiredness: EssentialNutrient,
  supplementation: EssentialNutrient,
  nutrients: EssentialNutrient,

  hydration: WaterIntake,
  'water intake': WaterIntake,
  'electrolyte imbalances': WaterIntake,

  hba1c: BloodGlucose,
  glucose: BloodGlucose,
  insulin: BloodGlucose,
  diabetes: BloodGlucose,
  prediabetes: BloodGlucose,

  // thyroid: Thyroid,
  'blood test': BloodTest,
  'vitamin d': VitaminD,
  choleterol: Choleterol,
  // lipid: Choleterol,
  bone: Bone,
  calcium: Bone,
  // lung: Lung,
  electrocardiogram: ElectroCardiogram,
  // heart: Heart,
  // cardiovascular: Heart,
  medicine: Medicine,
  'general test': GeneralTest,
  diet: Diet,
  exercise: Exercise,
  // 'water intake': WaterIntake,
  // lipid: LipidProfile,
  // metabolic: MetabolicPanel,
  // hydration: Hydration,
  // hba1c: BloodGlucose,
});

export const RECOMMENDATIONS_NAME_MAPPER = Object.freeze({
  'blood sugar': 'Blood Sugar & Diabetes Monitoring',

  cbc: 'Complete Blood Count (CBC)',
  hemoglobin: 'Complete Blood Count (CBC)',
  'white blood cell': 'Complete Blood Count (CBC)',
  'red blood cell': 'Complete Blood Count (CBC)',
  // anemia: 'Complete Blood Count (CBC)',
  // iron: 'Complete Blood Count (CBC)',
  'blood count': 'Complete Blood Count (CBC)',

  cmp: 'Comprehensive Metabolic Panel (CMP)',
  electrolytes: 'Comprehensive Metabolic Panel (CMP)',
  metabolic: 'Comprehensive Metabolic Panel (CMP)',

  lipid: 'Lipid Profile',
  cholesterol: 'Lipid Profile',
  ldl: 'Lipid Profile',
  triglycerides: 'Lipid Profile',

  pulmonary: 'Respiratory Function',
  respiratory: 'Respiratory Function',
  'oxygen saturation': 'Respiratory Function',
  lung: 'Respiratory Function',
  pft: 'Respiratory Function',

  echocardiogram: 'Cardiovascular Health',
  heart: 'Cardiovascular Health',
  ecg: 'Cardiovascular Health',
  cardiovascular: 'Cardiovascular Health',
  cardiac: 'Cardiovascular Health',
  'electrocardiogram (ecg)': 'Cardiovascular Health',
  bradycardia: 'Cardiovascular Health',
  pulse: 'Cardiovascular Health',
  prq: 'Cardiovascular Health',
  cardiorespiratory: 'Cardiovascular Health',
  'blood pressure': 'Cardiovascular Health',
  'holter monitor': 'Cardiovascular Health',

  ferritin: 'Iron & Anemia Investigation',
  iron: 'Iron & Anemia Investigation',
  // hemoglobin: 'Iron & Anemia Investigation',
  anemia: 'Iron & Anemia Investigation',

  thyroid: 'Thyroid Function',
  tsh: 'Thyroid Function',
  t3: 'Thyroid Function',
  t4: 'Thyroid Function',
  hashimoto: 'Thyroid Function',
  hormone: 'Thyroid Function',
  'thyroid function test': 'Thyroid Function',

  'liver function': 'Liver Function',
  alt: 'Liver Function',
  alp: 'Liver Function',
  bilirubin: 'Liver Function',

  creatinine: 'Kidney Function',
  egfr: 'Kidney Function',
  'kidney function': 'Kidney Function',
  bun: 'Kidney Function',

  sleep: 'Sleep Monitoring',
  apnea: 'Sleep Monitoring',
  polysomnography: 'Sleep Monitoring',
  'sleep study': 'Sleep Monitoring',
  'poor sleep': 'Sleep Monitoring',

  'stress management': 'Stress and Mental Health',
  cortisol: 'Stress and Mental Health',
  'mental health evaluation': 'Stress and Mental Health',
  hrv: 'Stress and Mental Health',
  'stress index': 'Stress and Mental Health',

  deficiency: 'Nutritional and Deficiency Assessment',
  vitamins: 'Nutritional and Deficiency Assessment',
  folate: 'Nutritional and Deficiency Assessment',
  b12: 'Nutritional and Deficiency Assessment',
  tiredness: 'Nutritional and Deficiency Assessment',
  supplementation: 'Nutritional and Deficiency Assessment',

  inflammation: 'Inflammatory and Immune Health',
  crp: 'Inflammatory and Immune Health',
  'immune system': 'Inflammatory and Immune Health',

  hydration: 'Hydration and Electrolyte Balance',
  'water intake': 'Hydration and Electrolyte Balance',
  'electrolyte imbalances': 'Hydration and Electrolyte Balance',

  hba1c: 'Blood Sugar & Diabetes Monitoring',
  glucose: 'Blood Sugar & Diabetes Monitoring',
  insulin: 'Blood Sugar & Diabetes Monitoring',
  diabetes: 'Blood Sugar & Diabetes Monitoring',
  prediabetes: 'Blood Sugar & Diabetes Monitoring',
});

export const getRecommendationImg = (stepKey: string) => {
  for (const [key, img] of Object.entries(REPORT_IMAGE_MAPPER)) {
    const regex = new RegExp(key, 'i');
    if (regex.test(stepKey)) {
      return img;
    }
  }
  return undefined;
};

export const getRecommendationName = (desc: string) => {
  for (const [key, name] of Object.entries(RECOMMENDATIONS_NAME_MAPPER)) {
    const regex = new RegExp(key, 'i');
    if (regex.test(desc)) {
      return name;
    }
  }
  return undefined;
};
